/// <amd-module name="Wit/HtmlEditor/Utils/WorkItemLinks" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssLocationService } from "VSS/Platform/Location";

const originalUrlAttribute = "data-html-editor-org-href";
const clickableAnchorPattern = /(<a\s+([^>]*\s+)?)(data\-html\-editor\-org\-href="([^"]*)")(\s?)([^>]*>)/gm;
const xmvwitUriPattern = /^x-mvwit:workitem\/([0-9]+)$/;

export function makeAllWorkItemHyperlinksClickable(element: HTMLElement, pageContext: IVssPageContext) {
    element.querySelectorAll("a[href]").forEach(a => {
        makeWorkItemHyperlinkClickable(a as HTMLAnchorElement, pageContext);
    });
}

export function makeWorkItemHyperlinkClickable(anchor: HTMLAnchorElement, pageContext: IVssPageContext) {
    const locationService = pageContext.getService<IVssLocationService>("IVssLocationService");
    const originalHref = anchor.href;
    const xmvwitResult = xmvwitUriPattern.exec(originalHref);

    if (!xmvwitResult) {
        return;
    }

    const workItemId = xmvwitResult[1];
    const workItemEditUrl = locationService.routeUrl("ms.vss-work-web.new-work-item-form-route-collection", {
        id: workItemId
    });

    anchor.href = workItemEditUrl;
    anchor.setAttribute(originalUrlAttribute, originalHref);
}

export function revertWorkItemHyperlinks(content: string): string {
    if (!content) {
        return content;
    }

    return content.replace(clickableAnchorPattern, (...groups: string[]): string => {
        const hasTrailingSpace = !!groups[5];
        let start = hasTrailingSpace ? groups[1] : groups[1].slice(0, -1);
        start = start.replace(/href="[^"]*"/, `href="${groups[4]}"`);
        const end = groups[6];
        return `${start}${end}`;
    });
}
